module.exports = __webpack_public_path__ + "img/neo-burger-simple.09f946ad.svg";